"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateQueryString = void 0;
const querystring_1 = __importDefault(require("querystring"));
/**
 * Generate query string from the object
 * Podio authentication request needs params in the form of FormData
 * To convert to FormData, use querystring library
 * @param obj
 * @returns
 */
function generateQueryString(obj) {
    return querystring_1.default.stringify(obj);
}
exports.generateQueryString = generateQueryString;
